import NotificationContainerView from 'ui/login-bar/mixins/container-view';
import { notificationStatusModel } from 'models/NotificationStatusModel';
import controller from 'ui/login-bar/controller';

const elements = {
  container: '.c-notification__articles',
  notificationsList: '.notifications-list',
  loader: '.notifications-loader',
  showMore: '.notifications-more.show-more',
  showOlder: '.notifications-more.show-older',
  noNotificationTrigger: '.notification-none',
};

export default class ArticlesNotificationContainerView extends NotificationContainerView {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
    notificationStatusModel.addEventListener('articlesRefreshed', this.updateTooltip.bind(this));
    model.addEventListener('updated', this.update.bind(this));

    this.initSizes($(elements.container));

    const self = this;
    self.applyResizeEvent($(elements.container));
    $(window).resize(function() {
      self.applyResizeEvent($(elements.container));
    });
  }
  update() {
    const container = this.rootEl.find(elements.notificationsList);
    const articles = _(this.model.get('articles')).take(6).value();
    this.fillLastLogin();
    container.empty();
    if (articles.length) {
      articles.forEach(this.addMessage.bind(this, 'article'));
      this.rootEl.find(elements.showMore)
        .removeClass('fn-hidden');
      this.rootEl.find(elements.noNotificationTrigger)
        .addClass('fn-hidden');
      this.rootEl.find(elements.showOlder)
        .addClass('fn-hidden');
    } else {
      this.rootEl.find(elements.noNotificationTrigger)
        .removeClass('fn-hidden');
      this.rootEl.find(elements.showOlder)
        .removeClass('fn-hidden');
      this.rootEl.find(elements.showMore)
        .addClass('fn-hidden');
    }
    this.rootEl.find(elements.loader)
      .addClass('fn-hidden');
  }
  render() {
    this.bulkDockTriggers()
      .on('click', () => {
        setTimeout(() => {
          if (this.collapsed) {
            this.rootEl.find(elements.notificationsList).empty();
            this.rootEl.find(elements.loader).removeClass('fn-hidden');
            controller.updateArticlesModel();
          }
        }, 10);
      });
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/articles/container-view.js